var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgYt = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" }, props, { children: _jsx("path", { fill: "currentColor", d: "M19.666 7.64c-.184-.645-.727-1.154-1.415-1.326C17.003 6 12 6 12 6s-5.003 0-6.251.314c-.688.172-1.23.68-1.415 1.325C4 8.81 4 12 4 12s0 3.19.334 4.36c.184.646.727 1.154 1.415 1.326C6.997 18 12 18 12 18s5.003 0 6.251-.314c.689-.172 1.23-.68 1.415-1.326C20 15.19 20 12 20 12s0-3.19-.334-4.36ZM10.4 14.598V9.402L15.2 12l-4.8 2.598Z" }) }))); };
export default SvgYt;
